module.exports = __webpack_public_path__ + "media/images/cereale-desktop-xl-1dc24a40a24399ece0b36d526e328e2f.jpg";